import { Header } from '@lightspeed/design-system-react'
import { VendImage } from '@vend/react-utilities'
import React, { FC } from 'react'
import { useT } from '@transifex/react'
import { LSPAYModalContent } from './LSPAYModalContent'

interface Props {
  isRefund?: boolean
}

export const Processing: FC<Props> = ({ isRefund }) => {
  const t = useT()
  const processingHeader = isRefund
    ? t('Processing refund', {
        _context: 'Processing refund step header',
      })
    : t('Processing payment', {
        _context: 'Processing payment step header',
      })
  return (
    <LSPAYModalContent>
      <VendImage
        relativeImagePath="payments/processing-refund-v1.svg"
        relativeDarkImagePath="payments/processing-refund-darkmode-v1.svg"
      />
      <Header type={isRefund ? 'heading' : 'sub-heading'} level="2">
        {processingHeader}
      </Header>
    </LSPAYModalContent>
  )
}
